import React, { useState, useEffect } from "react";
import { ToolsCard } from "./ToolsCard";
import figma from "./icons/Icon.png";
import sketch from "./icons/Icon (1).png";
import adobexd from "./icons/Icon (2).png";
import photoshop from "./icons/psd-icon.png";
import adobeill from "./icons/adobeIllustrator-icon.svg";
import canva from "./icons/canva-icon (1).svg";

import react from "./icons/Icon (5).png";
import tailwind from "./icons/tailwind-icon.svg";
import webflow from "./icons/webflow-icon.svg";
import vuejs from "./icons/vueJS-icon.svg";
import ionic from "./icons/Icon (4).png";
import bootstrap from "./icons/Icon (1).svg";
import angular from "./icons/angluar-icon (1).svg";
import html from "./icons/html5-icon (1).svg";

export const ToolsUsed = ({ data, setData }) => {
  const tools = {
    ui: [
      { id: 1, icon: figma, name: "Figma" },
      { id: 2, icon: sketch, name: "Sketch" },
      { id: 3, icon: adobexd, name: "Adobe XD" },
      { id: 4, icon: photoshop, name: "Photoshop" },
      { id: 5, icon: adobeill, name: "Adobe Illustrator" },
      { id: 6, icon: canva, name: "Canva" },
    ],
    frontBack: [
      { id: 7, icon: react, name: "React" },
      { id: 8, icon: ionic, name: "Ionic" },
      { id: 9, icon: vuejs, name: "vueJs" },
      { id: 10, icon: angular, name: "Angular" },
      { id: 11, icon: html, name: "Html & Css" },
      { id: 12, icon: bootstrap, name: "Bootstrap" },
      { id: 13, icon: webflow, name: "Webflow" },
      { id: 14, icon: tailwind, name: "Tailwind Css" },
    ],
  };

  const [selectedTools, setSelectedTools] = useState({ ui: [], frontBack: [] });

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      toolsUsed: selectedTools,
    }));
  }, [selectedTools, setData]);

  const handleToolSelect = (category, toolName) => {
    setSelectedTools((prev) => {
      const isSelected = prev[category].includes(toolName);
      const updatedCategory = isSelected
        ? prev[category].filter((tool) => tool !== toolName)
        : [...prev[category], toolName];
      return { ...prev, [category]: updatedCategory };
    });
  };

  return (
    <div className="bg-[#f0f0f0] dark:bg-[#282828] p-4 rounded-lg my-4">
      <div className="flex items-center space-x-2">
        <div className="bg-[#90E9CE] w-4 h-4 rounded-lg" />
        <h1>Tools Used</h1>
      </div>
      <h1 className="py-4">UI & GRAPHIC DESIGN</h1>
      {tools.ui.map((ui) => (
        <ToolsCard
          key={ui.id}
          icon={ui.icon}
          name={ui.name}
          onSelect={() => handleToolSelect("ui", ui.name)}
          checked={selectedTools.ui.includes(ui.name)}
        />
      ))}
      <div className="py-3" />
      <h1>FRONT-END & BACK-END DEVELOPMENT</h1>
      {tools.frontBack.map((tool) => (
        <ToolsCard
          key={tool.id}
          icon={tool.icon}
          name={tool.name}
          onSelect={() => handleToolSelect("frontBack", tool.name)}
          checked={selectedTools.frontBack.includes(tool.name)}
        />
      ))}
    </div>
  );
};
